import React from 'react';

interface IPauseIconProps {
  color?: string;
}
const PauseIcon = ({ color = '#fff' }: IPauseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-pause"
      width="48"
      height="48"
      viewBox="0 0 32 32"
      fillRule="evenodd"
      fill={color}
    >
      <path d="M5 4h6v24H5zm16 0h6v24h-6z" />
    </svg>
  );
};

export default PauseIcon;
